import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners, accordion } from "../components/data";
import AccordionBlock from "../components/blocks/accordionBlock";

export default function Proggram() {
    return(
        <div className="Proggram">
            <TopBanner title={Banners[5].title} />
            <div className="container">
                <p className="textPO text-center">Наши услуги по разработке программного обеспечения на заказ – это привлекательные и интеллигентные решения, которые доказали свою эффективность. На протяжении многих лет AITI Guru разрабатывает программное обеспечение, широкий спектр пользовательских программных решений для бизнеса</p>
            </div>
            <AccordionBlock accordions={ accordion } />
        </div>
    )
}